import { Injectable } from '@angular/core';
import { forkJoin, Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { DataFhirAdapter, DataFhirModel } from '../data.model';
import { DictionariesCollectionService } from '../dictionaries/dictionaries-collection.service';
import { BasePersonAdapter, Human } from './base-person.model';

export interface Patient extends DataFhirModel<fhir4.Patient>, Human {
  matrixId?: string | null;
}

@Injectable({
  providedIn: 'root',
})
export class PatientAdapter extends DataFhirAdapter<Patient> {
  constructor(
    private humanAdapter: BasePersonAdapter,
    protected dictionariesCollection: DictionariesCollectionService,
  ) {
    super('Patient', dictionariesCollection);
  }

  protected blankResource(): fhir4.Patient {
    return {
      resourceType: 'Patient',
    };
  }

  fromResource$(fhirPatient: fhir4.Patient): Observable<Patient> {
    return forkJoin([
      super.fromResource$(fhirPatient),
      this.humanAdapter.fromResource$(fhirPatient),
    ]).pipe(
      map(([baseItem, human]) => {
        return {
          ...baseItem,
          ...human,
        };
      }),
    );
  }

  toResource(patient: Patient, options): fhir4.Patient {
    return null;
  }
}
